'use client';

/**
 * Chat-surface card registry — `content_key` → React component.
 *
 * Single source of truth for "what does each chat-surface card render?"
 * Mirrors `INSIGHTS_CARD_REGISTRY` and `CANVAS_CARD_REGISTRY` exactly —
 * same primitive, three surfaces. Adding a chat card =
 * one decoration in `klyde_edge/composition/cards/messaging.py`
 * (the spec) + one entry here (the component).
 *
 * Cards in this registry expect to be mounted *inside* a
 * `<ChatSurfaceProvider />` — they read shared chat state
 * (single fetch, sibling tab, compose context) from that provider
 * via `useChatSurface()`.
 *
 * @see klyde_edge/composition/cards/messaging.py
 * @see klyde_edge/ui_config/docs/right_rail_and_canvas_ux_direction.md
 *
 * @layer presentation
 * @arch_component_type registry
 * @arch_domain messaging
 */

import { ChatThreadCard } from './chat-thread-card';
import { ComposeMessageCard } from './compose-message-card';

type ChatCardComponent = React.ComponentType;

export const CHAT_CARD_REGISTRY: Record<string, ChatCardComponent> = {
  chat_thread: ChatThreadCard,
  compose_message: ComposeMessageCard,
  // Future cards drop in here as the chat surface grows
  // (e.g. contacts, suggested replies, tender comparison sub-card).
};
